"use client";

export default function BlogSkeleton() {
    return (
        <section className="">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8">
                {/* Header Skeleton */}
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-12">
                    <div className="mb-4 sm:mb-0">
                        <div className="h-10 bg-gray-200 rounded-lg w-64 mb-2 animate-pulse"></div>
                        <div className="h-6 bg-gray-200 rounded w-48 animate-pulse"></div>
                    </div>
                    <div className="h-8 bg-gray-200 rounded-lg w-32 animate-pulse"></div>
                </div>

                {/* Blog Posts Grid Skeleton */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className="group cursor-pointer h-full bg-white rounded-sm shadow-lg transition-all flex flex-col">
                            {/* Content Section */}
                            <div className="flex flex-col h-full">
                                {/* Image Section Skeleton */}
                                <div className="relative rounded-xs aspect-[1800/900] block mb-6 overflow-hidden p-6">
                                    <div className="w-full h-full bg-gray-200 rounded animate-pulse"></div>
                                </div>

                                <div className="px-6 pb-6 flex flex-col justify-between flex-1">
                                    {/* Category Badge Skeleton */}
                                    <div className="mb-3">
                                        <div className="h-6 bg-gray-200 rounded w-20 animate-pulse"></div>
                                    </div>

                                    {/* Title Skeleton */}
                                    <div className="mb-3">
                                        <div className="h-6 bg-gray-200 rounded w-full mb-2 animate-pulse"></div>
                                        <div className="h-6 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                                    </div>

                                    {/* Excerpt Skeleton */}
                                    <div className="mb-4">
                                        <div className="h-4 bg-gray-200 rounded w-full mb-2 animate-pulse"></div>
                                        <div className="h-4 bg-gray-200 rounded w-2/3 animate-pulse"></div>
                                    </div>

                                    {/* Author Section Skeleton */}
                                    <div className="flex items-center space-x-3 mt-auto">
                                        <div className="h-10 w-10 bg-gray-200 rounded-full animate-pulse"></div>
                                        <div className="flex-1">
                                            <div className="h-4 bg-gray-200 rounded w-24 mb-1 animate-pulse"></div>
                                            <div className="h-3 bg-gray-200 rounded w-16 animate-pulse"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Pagination Skeleton */}
                <div className="flex items-center justify-center">
                    <div className="flex items-center space-x-2 bg-white rounded-lg shadow-sm border border-gray-200 p-2">
                        <div className="h-8 w-16 bg-gray-200 rounded animate-pulse"></div>
                        <div className="flex items-center space-x-1">
                            {Array.from({ length: 5 }).map((_, index) => (
                                <div key={index} className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
                            ))}
                        </div>
                        <div className="h-8 w-16 bg-gray-200 rounded animate-pulse"></div>
                    </div>
                </div>
            </div>
        </section>
    );
} 